<template>
    <div id="content">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "Content"
};
</script>